import { useState } from "react";
import { HashLink as Link } from 'react-router-hash-link'
// style imports
import {
    Typography,
    Container,
    Grid,
    IconButton,
    Button
} from "@mui/material"
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import { motion } from 'framer-motion'

// component imports
import Name from "./Name"

export default function Hero() {

    return (
        <Container sx={{ my: { xs: "2vh", sm: "10vh", xl: "20vh" }, mx: { xs: 0, sm: 2 } }} maxWidth="xl">
            <Grid container >
                <Grid item
                    xs={12}
                    sm={6}
                    sx={{ zIndex: 1 }}
                    component={motion.div}
                    initial={{ x: -1000 }}
                    animate={{ x: 0 }}
                    transition={{ type: 'spring', bounce: .3, duration: 1.7 }}>
                    <Name />
                    <Typography sx={{ fontSize: { xs: "1.3rem", sm: "1.5rem" } }} variant="h5" color="secondary" >
                        {'<full-stack></code-wizard>'}
                    </Typography>
                    <Typography sx={{ mt: 3, mr: { xs: 0, sm: 3 }, width: { xs: "100%", sm: "90%" }, fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                        Thank you so much for taking the time to check out my website!
                        My name is Kord Maurer, and I recently graduated from Emerging Digital Academy: an 800+ hour, 20 week Full Stack Software Engineering bootcamp.
                        I took the risk of quitting a stable job for the pursuit of a better career, and it was was one of the best decisions I've ever made.
                        I love that coding is such a creative pursuit, and I'm currently on the hunt to find a position at a company that allows me to continue my growth as a developer.
                    </Typography>
                    <Typography sx={{ mt: 3, mr: { xs: 0, sm: 3 }, fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                        In my spare time, I enjoy playing and listening to music, attending shows at our local music venues, playing video games, and getting outdoors to go for walks, bike rides, birdwatching, & setting up my hammock (when the weather is bearable.)
                    </Typography>
                    <motion.div style={{ display: 'flex', flexDirection: 'row' }} >
                        <IconButton
                            sx={{ my: 2 }}
                            component={motion.a}
                            whileHover={{ scale: 1.3, transition: { delay: 0 } }}
                            initial={{ x: -1000 }}
                            animate={{ x: 0 }}
                            transition={{ type: 'spring', bounce: .3, duration: 2 }}
                            size="large"
                            color="secondary"
                            href="https://www.linkedin.com/in/kord-maurer"
                            rel="noopener noreferrer"
                            target="_blank">
                            <LinkedInIcon sx={{ fontSize: '2em' }} />
                        </IconButton >
                        <IconButton
                            component={motion.a}
                            whileHover={{ scale: 1.3, transition: { delay: 0 } }}
                            initial={{ x: -1000 }}
                            animate={{ x: 0 }}
                            transition={{ type: 'spring', bounce: .3, duration: 2.2 }}
                            sx={{ my: 2 }}
                            size="large"
                            color="secondary"
                            href="https://github.com/PizzaPadawan/"
                            rel="noopener noreferrer"
                            target="_blank">
                            <GitHubIcon sx={{ fontSize: '2em' }} />
                        </IconButton>
                    </motion.div>
                    <motion.div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Link to="#projects" smooth >
                            <Button
                                component={motion.button}
                                sx={{ mx: { xs: 1, sm: 2 }, mb: { xs: 5, sm: 0 } }}
                                whileHover={{ scale: 1.3, transition: { delay: 0 } }}
                                initial={{ x: -1000 }}
                                animate={{ x: 0 }}
                                transition={{ type: 'spring', bounce: .3, duration: 2 }}
                                size="large"
                                variant="outlined"
                            >Projects
                            </Button>
                        </Link>
                        <Link to="#tooling" smooth>
                            <Button
                                component={motion.button}
                                sx={{ mx: { xs: 1, sm: 2 }, mb: { xs: 5, sm: 0 } }}
                                whileHover={{ scale: 1.3, transition: { delay: 0 } }}
                                initial={{ x: -1000 }}
                                animate={{ x: 0 }}
                                transition={{ type: 'spring', bounce: .3, duration: 2.2 }}
                                size="large"
                                variant="outlined"
                            >Tooling
                            </Button>
                        </Link>
                        <Link to="#contact" smooth>
                            <Button
                                component={motion.button}
                                sx={{ mx: { xs: 1, sm: 2 }, mb: { xs: 5, sm: 0 } }}
                                whileHover={{ scale: 1.3, transition: { delay: 0 } }}
                                initial={{ x: -1000 }}
                                animate={{ x: 0 }}
                                transition={{ type: 'spring', bounce: .3, duration: 2.4 }}
                                size="large"
                                variant="outlined"
                            >Contact
                            </Button>
                        </Link>
                    </motion.div>
                </Grid>
                <Grid item
                    xs={12}
                    sm={6}
                    sx={{
                        // backgroundImage: `url(${process.env.PUBLIC_URL}/images/party.jpg)`,
                        // backgroundSize: '100%',
                        // backgroundRepeat: 'no-repeat',
                        // borderRadius: '50%'
                    }}>
                    <motion.img
                        whileHover={{ scale: 1.04 }}
                        style={{ zIndex: -1, width: '100%', scale: 1.02, borderRadius: '50%' }}
                        src={`${process.env.PUBLIC_URL}/images/business1.jpg`} />
                </Grid>
                <Grid item>
                    <motion.h1 initial={{ opacity: 0 }}>Kord Maurer</motion.h1>
                </Grid>
            </Grid>
        </Container >
    )
}